import humps from 'lodash-humps-ts';
import { omit } from 'lodash';
import { snakes } from '@utils/lodash';
import { authAxios } from '@components/Auth';
import { HealthClaim } from '@models/HealthClaim';
import { API_V1_BASE } from '@config';
import { PaymentInfo } from '@models/PaymentInfo';

export interface CreateHealthClaimParams {
  insurancePolicyUserId: number;
  accidentHappenedAt: string;
  symptomsDescription: string;
  diagnosisDescription: string;
  coveredByOtherInsurance: boolean;
  noteOnOtherInsurance?: string;
  medicalDocuments: File[];
  identityDocuments: File[];
  totalClaimedAmount: number;
  mobileNumber: string;
  email?: string;
  paymentInfo: PaymentInfo;
  acceptTermsAndConditions: boolean;
}

export interface GetHealthClaimParams {
  id: number;
}

export interface UploadHealthClaimDocumentsParams extends GetHealthClaimParams {
  medicalDocuments: File[];
  identityDocuments: File[];
}

export class HealthClaimApi {
  static create = async ({ paymentInfo, ...rest }: CreateHealthClaimParams) => {
    return await authAxios
      .postForm(`${API_V1_BASE}/user/health_claims`, {
        ...omit(snakes(rest), ['medical_documents', 'identity_documents']),
        'medical_documents[]': rest.medicalDocuments,
        'identity_documents[]': rest.identityDocuments,
        'payment_info[payment_method]': paymentInfo.paymentMethod,
        'payment_info[bank_name]': paymentInfo.bankName,
        'payment_info[beneficiary_name]': paymentInfo.beneficiaryName,
        'payment_info[bank_account]': paymentInfo.bankAccount,
      })
      .then((response) => humps(response.data) as HealthClaim);
  };

  static get = async ({ id }: GetHealthClaimParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/health_claims/${id}`)
      .then((response) => humps(response.data) as HealthClaim);
  };

  static uploadDocuments = async ({ id, ...documents }: UploadHealthClaimDocumentsParams) => {
    return await authAxios
      .putForm(`${API_V1_BASE}/user/health_claims/${id}/upload_documents`, {
        ...omit(snakes(documents), ['medical_documents', 'identity_documents']),
        'medical_documents[]': documents.medicalDocuments,
        'identity_documents[]': documents.identityDocuments,
      })
      .then((response) => humps(response.data) as HealthClaim);
  }
}
